const formatNumber = (number: number) => {
  if (!number || number === 0) return '-';
  return new Intl.NumberFormat('sv-SE').format(number);
};

export { formatNumber };
